<template>
  <div>
    <el-dialog title="解约账户" :visible.sync="dialogFormVisible" width="600px" center :close-on-click-modal="false" @open="init" @close="closeDialog">
      <div v-loading="loading">
        <el-form ref="form" :model="form" label-width="80px">

            <div style="margin-left: 27px;margin-bottom: 10px;">请选择要解约的银行账户</div>
            <el-form-item label="">
              <el-select v-model="bank" placeholder="请选择" @change="slectbanknumber" value-key="bankCardNo" size="small" style="width: 250px;margin-left: -50px;">
                <el-option v-for="(item,index) in banklist" :key="index" :label="'尾号'+item.bankCardNo.substr(-4,4)+'（'+item.bankNo+'）'" :value="item"></el-option>
              </el-select>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="closeDialog">取 消</el-button>
          <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="cofirm">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="确认解约" :visible.sync="dialogFormVisible2" width="600px" center :close-on-click-modal="false" @close="closeDialog2">
      <div v-loading="loading">
        <div style="text-align: center;width: 100%;margin-bottom: 30px;">解约后您的数据流水将全部被清除，确定要解约吗？</div>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button style="width: 120px;background: #9B9B9B;border: none;" size="small" type="primary" @click="closeDialog2">取 消</el-button>
          <el-button style="width: 120px;background: #269D7B;border: none;" size="small" type="primary" @click="cofirm2">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    props: ['visible'],
  	data(){
  		return {
        dialogFormVisible:false,
        dialogFormVisible2:false,
        loading:false,
        bank:'',
        banklist:[],
        form:{
          bankNo:''
        },
  		}
  	},
  	created(){

  	},
  	computed: {

  	},
  	methods:{
      closeDialog(){
        this.dialogFormVisible=false
        this.$emit('refresh',false)
      },
      closeDialog2(){
        this.dialogFormVisible2=false
        this.$emit('ref2','water')
      },
  		slectbanknumber(val){
        this.form.bankNo=val.bankCardNo
  		},
      cofirm(){
        this.dialogFormVisible=false
        this.dialogFormVisible2=true
      },
      cofirm2(){
        this.loading=true
        this.$http.post('/bankContract/breakContract',this.form).then((res)=>{
          this.loading=false
          if(res && res.data.code == '1'){
            this.$message.success(res.data.data.return_msg);
            this.closeDialog2();
            this.closeDialog();
            this.init();
            if(this.banklist.length==0){
              this.$emit('ref2','shouye');
            }else{
              this.$emit('ref2','water');
            }
          }
        })
      },
      init(){
        this.loading=true
        this.$http.post('/bankContract/getAllBankNo',{}).then((res)=>{
          this.loading=false
          if(res && res.data.code == '1'){
            this.banklist=res.data.data
          }
        })
      }
  	},
  	mounted() {

  	},
    watch: {
      　　visible: {
    　　　　handler(newValue, oldValue) {
              if(newValue.showdialog){
                this.dialogFormVisible=true
              }
    　　　　},
    　　　　deep: true,
           immediate: true
      　　},

        }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/bankwater/arefire.vue